import './footer.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCode } from '@fortawesome/free-solid-svg-icons'
import ExtraLinks from './ExtraLinks'
import SocialMedia from './SocialMedia'
import data from '../FakeData/index.json'
import UseFetch from '../UseFetch'
import Skeleton from 'react-loading-skeleton'
import mainData from '../FetchDataLinks'

function Footer() {

    let a = 0;
    let b = 0;

    const { blogs, loading } = UseFetch(mainData.famous)


    window.onscroll = function () {
        scrollFunction()
    };

    function scrollFunction() {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            document.getElementById("movetop").style.display = "block";
        } else {
            document.getElementById("movetop").style.display = "none";
        }
    }


    function topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
    return (
        <section className="app-footer">
            <footer className="footer-28 py-5">
                <div className="footer-bg-layer">
                    <div className="container py-lg-3">
                        <div className="row footer-top-28">
                            <div className="col-lg-4 footer-list-28 copy-right mb-lg-0 mb-sm-5 mt-sm-0 mt-4">
                                <a className="navbar-brand mb-3" href="/">
                                    <span><FontAwesomeIcon icon={faCode} /></span> <span style={{ marginTop: '7px', fontSize: 'revert' }}> Down the Code</span></a>
                                <p className="copy-footer-28"> © 2020. All Rights Reserved. </p>
                                <h5 className="mt-2">Design by <a href="https://amanojha.pythonanywhere.com/">Aman Ojha</a></h5>
                            </div>
                            <div className="col-lg-8 row">
                                <div className="col-sm-4 col-6 footer-list-28">
                                    <h6 className="footer-title-28">Useful links</h6>
                                    <ul>
                                        {data[0].links.map((link) => {
                                            a++;
                                            return <ExtraLinks key={`ExtraLinkSkeleton${a}`} location={link} />
                                        })}
                                    </ul>
                                </div>
                                <div className="col-sm-4 col-6 footer-list-28">
                                    <h6 className="footer-title-28">Categories</h6>
                                    <ul>
                                        {!loading && blogs.map((cat) => {
                                            return <ExtraLinks key={cat.id} location={cat.Cateogary} />
                                        })}
                                        {loading && Array(4).fill().map(() => {
                                            b++;
                                            return <li key={`Skeletonli${b}`}><a href={`/`}><Skeleton key={`Skeleton${b}`} /></a></li>
                                        })}
                                    </ul>
                                </div>
                                <div className="col-sm-4 col-6 footer-list-28 mt-sm-0 mt-4">
                                    <h6 className="footer-title-28">Social Media</h6>
                                    <ul className="social-icons">
                                        <SocialMedia key={`facebook`} social='facebook' />
                                        <SocialMedia key={`twitter`} social='twitter' />
                                        <SocialMedia key={`linkedin`} social='linkedin' />
                                        <SocialMedia key={`github`} social='github' />
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <button onClick={() => { topFunction() }} id="movetop" title="Go to top">
                <span className="fa fa-angle-up" />
            </button>
        </section>

    )
}

export default Footer
